import { IChartVariant } from './../shared.d';
import {
  filterBySelectedVariant,
  filterBySelectedCustomer,
  filterByLocal,
} from '../helpers/chartFilters';

export const getChartRows = ({
  filteredCharts,
  selectedChartVariant,
  selectedCustomer,
}: IUseChartRows): any[] | null => {
  if (!filteredCharts) return null;

  if (selectedChartVariant && selectedChartVariant.id) {
    return filteredCharts
      .filter(filterBySelectedVariant(selectedChartVariant))
      .filter(filterByLocal);
  }

  if (selectedCustomer && selectedCustomer.value !== 'all') {
    return filteredCharts
      .filter(filterBySelectedCustomer(selectedCustomer))
      .filter(filterByLocal);
  }

  return filteredCharts;
};

/**
 * This hook filters the charts based on customer (e.g 'Spotify')
 * or a specific variant of a customer chart (e.g 'Spotify Top 200 Daily').
 *
 * @returns {Array} array containing only charts for the selected customer.
 */
interface IUseChartRows {
  filteredCharts: any[] | null;
  selectedChartVariant: IChartVariant;
  selectedCustomer?: any | null;
}
